/**
 * InviteParentsButton
 */

import React from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useDialog from 'containers/Dialog/useDialog.js';
import messages from './messages.js';

function InviteParentsButton() {
  const intl = useIntl();
  const title = intl.formatMessage(messages.inviteParents);
  const navigate = useNavigate();
  const { dlgConfirm } = useDialog();
  function handleIndividual() {
    dlgConfirm({ message: messages.findStudent }).then(() => navigate('#student'));
  }
  return (
    <DropdownButton
      variant="light"
      title={title}
      key={1}
      align="end"
      id="invite-parents"
    >
      <Dropdown.Item as="button" eventkey="1" onClick={handleIndividual}><FormattedMessage {...messages.individualParent} /></Dropdown.Item>
      <Dropdown.Item as="button" eventkey="2" onClick={() => navigate('/admin/users/invite/parent')}><FormattedMessage {...messages.manyParents} /></Dropdown.Item>
    </DropdownButton>
  );
}

InviteParentsButton.propTypes = {
};

export default InviteParentsButton;
